export default __webpack_public_path__ + "static/events-dark-c3a970d5362789758e7d6bddb85c0635.png";